import {
    IIssueHardwareHealthResponse,
    IIssueMachineHealthResponse,
    IssueHardwareHealthResponse,
} from '@kcftech/prometheustypescriptapiclient';
import { NoValue } from 'components/no_value/NoValue';
import { KCFOnlyLozenge } from 'pages/Desk/issues/issue_card/KCFOnlyLozenge';
import { FormattedText } from 'pages/Desk/issues/issue_details/feed/styled';
import { memo, useRef } from 'react';
import { HoverTooltip } from 'shared/hover_tooltip/HoverTooltip';
import styled, { css } from 'styled-components';
import { link, linkShifted } from 'styles/theme';

const IssueNumberContainer = styled.div<{ $styles?: ReturnType<typeof css> }>`
    display: flex;
    gap: 0.8rem;
    align-items: center;
    ${(props) => props.$styles}
`;

const IssueNumber = styled.div<{ $styles?: ReturnType<typeof css> }>`
    display: inline-block;
    color: ${link};
    &:hover {
        color: ${linkShifted};
    }
    ${(props) => props.$styles}
`;

const PopupContent = styled.div<{ $styles?: ReturnType<typeof css> }>`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    width: 40rem;
    max-height: 30rem;
    ${(props) => props.$styles}
`;

const Title = styled.h4<{ $styles?: ReturnType<typeof css> }>`
    margin: 0;
    padding: 0;
    ${(props) => props.$styles}
`;

const Section = styled.div<{ $styles?: ReturnType<typeof css> }>`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    ${(props) => props.$styles}
`;

type IssuePreviewPopupProps = Readonly<{
    issue: IIssueHardwareHealthResponse | IIssueMachineHealthResponse;
    containerStyles?: ReturnType<typeof css>;
    issueNumberStyles?: ReturnType<typeof css>;
    popupStyles?: ReturnType<typeof css>;
    titleStyles?: ReturnType<typeof css>;
    sectionStyles?: ReturnType<typeof css>;
}>;

function IssuePreviewPopup({
    issue,
    containerStyles,
    issueNumberStyles,
    popupStyles,
    titleStyles,
    sectionStyles,
}: IssuePreviewPopupProps) {
    const tooltipAnchorRef = useRef<HTMLDivElement>(null);

    return (
        <>
            <IssueNumberContainer $styles={containerStyles}>
                <IssueNumber ref={tooltipAnchorRef} $styles={issueNumberStyles}>
                    #{issue.IssueNumber}
                </IssueNumber>
                {issue instanceof IssueHardwareHealthResponse && issue.IsInternal && (
                    <KCFOnlyLozenge />
                )}
            </IssueNumberContainer>
            <HoverTooltip anchorRef={tooltipAnchorRef} hideDelayMs={0}>
                <PopupContent $styles={popupStyles}>
                    <Section $styles={sectionStyles}>
                        <Title $styles={titleStyles}>Description</Title>
                        <FormattedText className="ellipsis-3-lines">
                            {issue.Description || <NoValue />}
                        </FormattedText>
                    </Section>
                    <Section $styles={sectionStyles}>
                        <Title $styles={titleStyles}>Recommendation</Title>
                        <FormattedText className="ellipsis-3-lines">
                            {issue.RecommendedAction || <NoValue />}
                        </FormattedText>
                    </Section>
                </PopupContent>
            </HoverTooltip>
        </>
    );
}

const memoIssuePreviewPopup = memo(IssuePreviewPopup);
export { memoIssuePreviewPopup as IssuePreviewPopup };
